import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
// import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
// import { ServerService } from 'src/app/services/server.service';
import { DatePipe } from '@angular/common';
// import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material';
// import { ClientLeadProfileEditModalComponent } from '../client-lead-profile/client-lead-profile-task-edit-modal/client-lead-profile-task-edit-modal.component';
// import {
//   ChangeDetectionStrategy,
//   ViewChild,
//   TemplateRef,
// } from '@angular/core';
// import {
//   startOfDay,
//   endOfDay,
//   subDays,
//   addDays,
//   endOfMonth,
//   isSameDay,
//   isSameMonth,
//   addHours,
// } from 'date-fns';
// import { Subject } from 'rxjs';
// import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
// import {
//   CalendarEvent,
//   CalendarEventAction,
//   CalendarEventTimesChangedEvent,
//   CalendarView,
// } from 'angular-calendar';
import { EventColor } from 'calendar-utils';
import { color } from 'highcharts';

const colors: Record<string, EventColor> = {
  red: {
    primary: 'red',
    secondary: '#FAE3E3',
    
  },
  yellow: {
    primary: 'yellow',
    secondary: '#D1E8FF',
  },
  green: {
    primary: 'green',
    secondary: '#FDF1BA',
  },
};

@Component({
  selector: 'app-scheduler-modal',
  // changeDetection: ChangeDetectionStrategy.OnPush,
  // encapsulation: ViewEncapsulation.None,
  templateUrl: './scheduler-modal.component.html',
  styleUrls: ['./scheduler-modal.component.scss']
})
export class SchedulerModalComponent implements OnInit {
  constructor(){}
//   @ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any>;

//   view: CalendarView = CalendarView.Month;

//   CalendarView = CalendarView;
//   pageLoader = true;
//   viewDate: Date = new Date();
//   projectInfo:any;
//   email:any;
//   dataView:false;
//   addMonthClass = true;
//   addWeekClass = false;
//   addDayClass = false;

//   phone:any;
//   modalData: {
//     action: string;
//     event: CalendarEvent;
//   };
//   transformedDate:any;
//   leadInfo = {}
//   dataResult = false;
//   clientLeadProfileEditModalComponent: MatDialogRef<ClientLeadProfileEditModalComponent>;
//   lead:any;
//   actions:any;
//   refresh = new Subject<void>();  
//   events: CalendarEvent[] = [];
//   userInfo = JSON.parse(localStorage.getItem('userInfo'));
//   // actions: CalendarEventAction[];
//   dateToday:any;
//   authToken = localStorage.getItem('token');
//   allTasks:any=[];
//   activeDayIsOpen: boolean = false;
//   constructor(
//     private dialogRef: MatDialogRef<SchedulerModalComponent>,
//     private modal: NgbModal,
//     private serverService:ServerService,
//     private datePipe: DatePipe,
//     private dialog: MatDialog,
//   ) { 
    
//   }

  ngOnInit() {
    // this.refresh.next();
    // this.getAllTask();
  }
//   dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
//     if (isSameMonth(date, this.viewDate)) {
//       if (
//         (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
//         events.length === 0
//       ) {
//         this.activeDayIsOpen = false;
//       } else {
//         this.activeDayIsOpen = true;
//       }
//       this.viewDate = date;
//     }
//   }

//   eventTimesChanged({
//     event,
//     newStart,
//     newEnd,
//   }: CalendarEventTimesChangedEvent): void {
//     this.events = this.events.map((iEvent) => {
//       if (iEvent === event) {
//         return {
//           ...event,
//           start: newStart,
//           end: newEnd,
//         };
//       }
//       return iEvent;
//     });
//     this.handleEvent('Dropped or resized', event);
//   }

//   handleEvent(action: string, event: CalendarEvent): void {
//     this.getAllTask["profileView"] = true
//     this.modalData = { event, action };
//     this.leadInfo = {name:this.modalData.event.actions[0]['lead'].name,}
  
//     console.log(this.modalData.event.actions[0]['lead_id'])
//   let url = "get_lead_client_remarks/?lead_id=" + this.modalData.event.actions[0]['lead_id'] + "&per_page=50&page=1"
//   this.serverService.getLeadRemarks(url, this.authToken).subscribe(
//       data => {
//         sessionStorage.setItem('remarks',JSON.stringify(data.client_remarks));
//       })
//     this.serverService.getLeadByIdForScheduler(this.modalData.event.actions[0]['lead_id'],this.authToken).subscribe((data)=>
//     {
//       // console.log(data);
//       this.modalData.event.actions[0] = {...this.modalData.event.actions[0]}
//       this.leadInfo = {...this.leadInfo,email:data.email,phone:data.phone,status_description:data.status_description}
//       sessionStorage.setItem('leadInfo',JSON.stringify(this.leadInfo));
//       this.dataResult = true;
//       if(this.dataResult){
//         this.projectInfo = {name:this.modalData.event.actions[0]['lead'].project['name']}
//         sessionStorage.setItem('projectInfo',JSON.stringify(this.projectInfo));
//         this.clientLeadProfileEditModalComponent = this.dialog.open(ClientLeadProfileEditModalComponent, {
//           hasBackdrop: true,
//           disableClose: false,
//           autoFocus: true,
//           width: '500px',
//           panelClass: 'cdk-overlay-panel-right-side',
//           data: this.modalData.event.actions[0]
//         });
//         this.clientLeadProfileEditModalComponent.afterClosed().subscribe(result => {
//           if (result != undefined) {
//           window.location.reload();
//           }
//         })
//       }
//     })
//   }

//   addEvent(): void {
//     this.events = [
//       ...this.events,
//       {
//         title: 'New event',
//         start: startOfDay(new Date()),
//         end: endOfDay(new Date()),
//         color: colors.red,
//         draggable: true,
//         resizable: {
//           beforeStart: true,
//           afterEnd: true,
//         },
//       },
//     ];
//   }

//   deleteEvent(eventToDelete: CalendarEvent) {
//     this.events = this.events.filter((event) => event !== eventToDelete);
//   }

//   setViewMonth(view: CalendarView,event) {
//     // console.log(view)
//     this.addWeekClass = false;
//     this.addDayClass = false;
//     this.addMonthClass = true;
    
//     this.view = view;
//     // console.log(event);
//     // console.log(this.addMonthClass)

//   }
//   setViewWeek(view: CalendarView,event) {
//     // console.log(view)
//     this.addMonthClass = false;
//     this.addWeekClass = true;
//     this.addDayClass = false;
//     this.view = view;
//     // console.log(event);
//     // console.log(this.addMonthClass)

//   }
//   setViewDay(view: CalendarView,event) {
//     // console.log(view)
//     // this.addMonthClass = true;
//     this.addMonthClass = false;
//     this.addWeekClass = false;
//     this.addDayClass = true;
//     this.view = view;
//     // console.log(event);
//     // console.log(this.addMonthClass)

//   }

//   closeOpenMonthViewDay() {
//     this.activeDayIsOpen = false;
//   }
//   close() {
//     this.dialogRef.close();
// }
// transformDate(date) {

//   date = this.datePipe.transform(date, 'EEEE, MMMM d, y, h:mm:ss a zzzz');
//   return date;

// }
// getAllTask()
// {
//   // this.refresh.next();
//   let colorSelected = {

//     primary: 'red',
//     secondary: '#FAE3E3',
//   }
//   this.serverService.getAllTasksByUser(this.authToken).subscribe((data)=>
//   {
//     this.allTasks = data.tasks;
//     for(let i=0; i< this.allTasks.length; i++) 
//     {
//       let obj =  this.allTasks[i];
//       if(!obj.done){
//       //  console.log(obj);
//       if(obj.priority == 1){
//         // colorSelected = 'red';
//         colorSelected = {...colors.red}

//       }
//       else if(obj.priority == 2){
//         colorSelected = {...colors.yellow}
//       }
//       else{
//         colorSelected = {...colors.green}
//       }
//       this.transformedDate = this.transformDate(obj.due_date)
//       this.events.push({
//       start: subDays(startOfDay(this.transformedDate), 0),
//       end: addDays(this.transformedDate, 0),
//       title: obj.task_category + ' - ' + obj.subject,
//       color: {...colorSelected},
//       actions: [obj],
//       allDay: true,
//       draggable: false,
//         })
//     }
//     this.refresh.next();
//   }
// })

// this.pageLoader = false;
// }
}
